// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file catpocs/v1/projects.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catpocs/v1/projects.proto.
 */
export const file_catpocs_v1_projects: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * ResourceQuota defines CPU and memory limits for a project
 *
 * @generated from message catpocs.v1.ResourceQuota
 */
export type ResourceQuota = Message<"catpocs.v1.ResourceQuota"> & {
  /**
   * e.g., "4" (cores)
   *
   * @generated from field: string cpu_limit = 1;
   */
  cpuLimit: string;

  /**
   * e.g., "8Gi"
   *
   * @generated from field: string memory_limit = 2;
   */
  memoryLimit: string;

  /**
   * e.g., "2"
   *
   * @generated from field: string cpu_request = 3;
   */
  cpuRequest: string;

  /**
   * e.g., "4Gi"
   *
   * @generated from field: string memory_request = 4;
   */
  memoryRequest: string;
};

/**
 * Describes the message catpocs.v1.ResourceQuota.
 * Use `create(ResourceQuotaSchema)` to create a new message.
 */
export const ResourceQuotaSchema: GenMessage<ResourceQuota> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 0);

/**
 * ProjectMember represents a member of a project
 *
 * @generated from message catpocs.v1.ProjectMember
 */
export type ProjectMember = Message<"catpocs.v1.ProjectMember"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string group_id = 2;
   */
  groupId: string;

  /**
   * "viewer", "editor", "admin"
   *
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;
};

/**
 * Describes the message catpocs.v1.ProjectMember.
 * Use `create(ProjectMemberSchema)` to create a new message.
 */
export const ProjectMemberSchema: GenMessage<ProjectMember> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 1);

/**
 * Project represents a platform project
 *
 * @generated from message catpocs.v1.Project
 */
export type Project = Message<"catpocs.v1.Project"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Kubernetes-compatible slug (auto-generated)
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * User-friendly display name
   *
   * @generated from field: string display_name = 13;
   */
  displayName: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string namespace = 4;
   */
  namespace: string;

  /**
   * @generated from field: string repo_url = 5;
   */
  repoUrl: string;

  /**
   * @generated from field: repeated string owners = 6;
   */
  owners: string[];

  /**
   * @generated from field: repeated catpocs.v1.ProjectMember members = 7;
   */
  members: ProjectMember[];

  /**
   * @generated from field: repeated string tags = 8;
   */
  tags: string[];

  /**
   * @generated from field: catpocs.v1.ResourceQuota resource_quota = 9;
   */
  resourceQuota?: ResourceQuota;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: int32 application_count = 12;
   */
  applicationCount: number;

  /**
   * AWS configuration (project-scoped; used by all applications in the project)
   *
   * IAM role ARN for GitHub Actions OIDC
   *
   * @generated from field: string aws_role_arn = 14;
   */
  awsRoleArn: string;

  /**
   * ECR registry URL (e.g., "123456.dkr.ecr.us-east-2.amazonaws.com")
   *
   * @generated from field: string ecr_registry = 15;
   */
  ecrRegistry: string;
};

/**
 * Describes the message catpocs.v1.Project.
 * Use `create(ProjectSchema)` to create a new message.
 */
export const ProjectSchema: GenMessage<Project> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 2);

/**
 * CreateProjectRequest is the request message for CreateProject
 *
 * @generated from message catpocs.v1.CreateProjectRequest
 */
export type CreateProjectRequest = Message<"catpocs.v1.CreateProjectRequest"> & {
  /**
   * User-friendly name (e.g., "Test Cat Poc")
   *
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string repo_url = 3;
   */
  repoUrl: string;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[];

  /**
   * @generated from field: catpocs.v1.ResourceQuota resource_quota = 5;
   */
  resourceQuota?: ResourceQuota;
};

/**
 * Describes the message catpocs.v1.CreateProjectRequest.
 * Use `create(CreateProjectRequestSchema)` to create a new message.
 */
export const CreateProjectRequestSchema: GenMessage<CreateProjectRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 3);

/**
 * CreateProjectResponse is the response message for CreateProject
 *
 * @generated from message catpocs.v1.CreateProjectResponse
 */
export type CreateProjectResponse = Message<"catpocs.v1.CreateProjectResponse"> & {
  /**
   * @generated from field: catpocs.v1.Project project = 1;
   */
  project?: Project;
};

/**
 * Describes the message catpocs.v1.CreateProjectResponse.
 * Use `create(CreateProjectResponseSchema)` to create a new message.
 */
export const CreateProjectResponseSchema: GenMessage<CreateProjectResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 4);

/**
 * GetProjectRequest is the request message for GetProject
 *
 * @generated from message catpocs.v1.GetProjectRequest
 */
export type GetProjectRequest = Message<"catpocs.v1.GetProjectRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.GetProjectRequest.
 * Use `create(GetProjectRequestSchema)` to create a new message.
 */
export const GetProjectRequestSchema: GenMessage<GetProjectRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 5);

/**
 * GetProjectResponse is the response message for GetProject
 *
 * @generated from message catpocs.v1.GetProjectResponse
 */
export type GetProjectResponse = Message<"catpocs.v1.GetProjectResponse"> & {
  /**
   * @generated from field: catpocs.v1.Project project = 1;
   */
  project?: Project;
};

/**
 * Describes the message catpocs.v1.GetProjectResponse.
 * Use `create(GetProjectResponseSchema)` to create a new message.
 */
export const GetProjectResponseSchema: GenMessage<GetProjectResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 6);

/**
 * ListProjectsRequest is the request message for ListProjects
 *
 * @generated from message catpocs.v1.ListProjectsRequest
 */
export type ListProjectsRequest = Message<"catpocs.v1.ListProjectsRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[];
};

/**
 * Describes the message catpocs.v1.ListProjectsRequest.
 * Use `create(ListProjectsRequestSchema)` to create a new message.
 */
export const ListProjectsRequestSchema: GenMessage<ListProjectsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 7);

/**
 * ListProjectsResponse is the response message for ListProjects
 *
 * @generated from message catpocs.v1.ListProjectsResponse
 */
export type ListProjectsResponse = Message<"catpocs.v1.ListProjectsResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.Project projects = 1;
   */
  projects: Project[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.ListProjectsResponse.
 * Use `create(ListProjectsResponseSchema)` to create a new message.
 */
export const ListProjectsResponseSchema: GenMessage<ListProjectsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 8);

/**
 * UpdateProjectRequest is the request message for UpdateProject
 *
 * @generated from message catpocs.v1.UpdateProjectRequest
 */
export type UpdateProjectRequest = Message<"catpocs.v1.UpdateProjectRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[];

  /**
   * @generated from field: catpocs.v1.ResourceQuota resource_quota = 4;
   */
  resourceQuota?: ResourceQuota;
};

/**
 * Describes the message catpocs.v1.UpdateProjectRequest.
 * Use `create(UpdateProjectRequestSchema)` to create a new message.
 */
export const UpdateProjectRequestSchema: GenMessage<UpdateProjectRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 9);

/**
 * UpdateProjectResponse is the response message for UpdateProject
 *
 * @generated from message catpocs.v1.UpdateProjectResponse
 */
export type UpdateProjectResponse = Message<"catpocs.v1.UpdateProjectResponse"> & {
  /**
   * @generated from field: catpocs.v1.Project project = 1;
   */
  project?: Project;
};

/**
 * Describes the message catpocs.v1.UpdateProjectResponse.
 * Use `create(UpdateProjectResponseSchema)` to create a new message.
 */
export const UpdateProjectResponseSchema: GenMessage<UpdateProjectResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 10);

/**
 * DeleteProjectRequest is the request message for DeleteProject
 *
 * @generated from message catpocs.v1.DeleteProjectRequest
 */
export type DeleteProjectRequest = Message<"catpocs.v1.DeleteProjectRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.DeleteProjectRequest.
 * Use `create(DeleteProjectRequestSchema)` to create a new message.
 */
export const DeleteProjectRequestSchema: GenMessage<DeleteProjectRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 11);

/**
 * DeleteProjectResponse is the response message for DeleteProject
 *
 * @generated from message catpocs.v1.DeleteProjectResponse
 */
export type DeleteProjectResponse = Message<"catpocs.v1.DeleteProjectResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message catpocs.v1.DeleteProjectResponse.
 * Use `create(DeleteProjectResponseSchema)` to create a new message.
 */
export const DeleteProjectResponseSchema: GenMessage<DeleteProjectResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 12);

/**
 * AddProjectMemberRequest is the request message for AddProjectMember
 *
 * @generated from message catpocs.v1.AddProjectMemberRequest
 */
export type AddProjectMemberRequest = Message<"catpocs.v1.AddProjectMemberRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string group_id = 3;
   */
  groupId: string;

  /**
   * @generated from field: string role = 4;
   */
  role: string;
};

/**
 * Describes the message catpocs.v1.AddProjectMemberRequest.
 * Use `create(AddProjectMemberRequestSchema)` to create a new message.
 */
export const AddProjectMemberRequestSchema: GenMessage<AddProjectMemberRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 13);

/**
 * AddProjectMemberResponse is the response message for AddProjectMember
 *
 * @generated from message catpocs.v1.AddProjectMemberResponse
 */
export type AddProjectMemberResponse = Message<"catpocs.v1.AddProjectMemberResponse"> & {
  /**
   * @generated from field: catpocs.v1.Project project = 1;
   */
  project?: Project;
};

/**
 * Describes the message catpocs.v1.AddProjectMemberResponse.
 * Use `create(AddProjectMemberResponseSchema)` to create a new message.
 */
export const AddProjectMemberResponseSchema: GenMessage<AddProjectMemberResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 14);

/**
 * RemoveProjectMemberRequest is the request message for RemoveProjectMember
 *
 * @generated from message catpocs.v1.RemoveProjectMemberRequest
 */
export type RemoveProjectMemberRequest = Message<"catpocs.v1.RemoveProjectMemberRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string group_id = 3;
   */
  groupId: string;
};

/**
 * Describes the message catpocs.v1.RemoveProjectMemberRequest.
 * Use `create(RemoveProjectMemberRequestSchema)` to create a new message.
 */
export const RemoveProjectMemberRequestSchema: GenMessage<RemoveProjectMemberRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 15);

/**
 * RemoveProjectMemberResponse is the response message for RemoveProjectMember
 *
 * @generated from message catpocs.v1.RemoveProjectMemberResponse
 */
export type RemoveProjectMemberResponse = Message<"catpocs.v1.RemoveProjectMemberResponse"> & {
  /**
   * @generated from field: catpocs.v1.Project project = 1;
   */
  project?: Project;
};

/**
 * Describes the message catpocs.v1.RemoveProjectMemberResponse.
 * Use `create(RemoveProjectMemberResponseSchema)` to create a new message.
 */
export const RemoveProjectMemberResponseSchema: GenMessage<RemoveProjectMemberResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 16);

/**
 * ListProjectMembersRequest is the request message for ListProjectMembers
 *
 * @generated from message catpocs.v1.ListProjectMembersRequest
 */
export type ListProjectMembersRequest = Message<"catpocs.v1.ListProjectMembersRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Number of members per page (default: 20)
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Number of members to skip for pagination
   *
   * @generated from field: int32 skip = 3;
   */
  skip: number;

  /**
   * Search query to filter members by identifier or email
   *
   * @generated from field: string search = 4;
   */
  search: string;

  /**
   * Filter by role: "viewer", "editor", "admin", or empty for all
   *
   * @generated from field: string role_filter = 5;
   */
  roleFilter: string;
};

/**
 * Describes the message catpocs.v1.ListProjectMembersRequest.
 * Use `create(ListProjectMembersRequestSchema)` to create a new message.
 */
export const ListProjectMembersRequestSchema: GenMessage<ListProjectMembersRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 17);

/**
 * ListProjectMembersResponse is the response message for ListProjectMembers
 *
 * @generated from message catpocs.v1.ListProjectMembersResponse
 */
export type ListProjectMembersResponse = Message<"catpocs.v1.ListProjectMembersResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.ProjectMember members = 1;
   */
  members: ProjectMember[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.ListProjectMembersResponse.
 * Use `create(ListProjectMembersResponseSchema)` to create a new message.
 */
export const ListProjectMembersResponseSchema: GenMessage<ListProjectMembersResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_projects, 18);

/**
 * ProjectService manages platform projects
 *
 * @generated from service catpocs.v1.ProjectService
 */
export const ProjectService: GenService<{
  /**
   * CreateProject creates a new project
   *
   * @generated from rpc catpocs.v1.ProjectService.CreateProject
   */
  createProject: {
    methodKind: "unary";
    input: typeof CreateProjectRequestSchema;
    output: typeof CreateProjectResponseSchema;
  },
  /**
   * GetProject retrieves a project by ID
   *
   * @generated from rpc catpocs.v1.ProjectService.GetProject
   */
  getProject: {
    methodKind: "unary";
    input: typeof GetProjectRequestSchema;
    output: typeof GetProjectResponseSchema;
  },
  /**
   * ListProjects lists all accessible projects
   *
   * @generated from rpc catpocs.v1.ProjectService.ListProjects
   */
  listProjects: {
    methodKind: "unary";
    input: typeof ListProjectsRequestSchema;
    output: typeof ListProjectsResponseSchema;
  },
  /**
   * UpdateProject updates a project
   *
   * @generated from rpc catpocs.v1.ProjectService.UpdateProject
   */
  updateProject: {
    methodKind: "unary";
    input: typeof UpdateProjectRequestSchema;
    output: typeof UpdateProjectResponseSchema;
  },
  /**
   * DeleteProject deletes a project
   *
   * @generated from rpc catpocs.v1.ProjectService.DeleteProject
   */
  deleteProject: {
    methodKind: "unary";
    input: typeof DeleteProjectRequestSchema;
    output: typeof DeleteProjectResponseSchema;
  },
  /**
   * AddProjectMember adds a member to a project
   *
   * @generated from rpc catpocs.v1.ProjectService.AddProjectMember
   */
  addProjectMember: {
    methodKind: "unary";
    input: typeof AddProjectMemberRequestSchema;
    output: typeof AddProjectMemberResponseSchema;
  },
  /**
   * RemoveProjectMember removes a member from a project
   *
   * @generated from rpc catpocs.v1.ProjectService.RemoveProjectMember
   */
  removeProjectMember: {
    methodKind: "unary";
    input: typeof RemoveProjectMemberRequestSchema;
    output: typeof RemoveProjectMemberResponseSchema;
  },
  /**
   * ListProjectMembers lists members of a project with pagination and search
   *
   * @generated from rpc catpocs.v1.ProjectService.ListProjectMembers
   */
  listProjectMembers: {
    methodKind: "unary";
    input: typeof ListProjectMembersRequestSchema;
    output: typeof ListProjectMembersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catpocs_v1_projects, 0);

